import { ADD_LAYERS } from '@tmapy/mapcore';
import { getInitialState } from './initialState';
import { LEGEND_SET_STATE, LEGEND_UPDATE_STATE } from '../constants';
export const legend = (state = getInitialState(), action) => {
    switch (action.type) {
        case LEGEND_SET_STATE: {
            return action.payload;
        }
        case LEGEND_UPDATE_STATE: {
            const { layerId, legendItems } = { ...action.payload };
            const updatedLegend = state.reduce((acc, item) => {
                if (item.layerId === layerId) {
                    item.items = legendItems;
                }
                acc.push(item);
                return acc;
            }, []);
            return updatedLegend;
        }
        case ADD_LAYERS: {
            const legendState = [...state];
            action.payload.forEach((layer) => legendState.push({ layerId: layer.id, type: layer.type, label: layer.label }));
            return legendState;
        }
        default: {
            return state;
        }
    }
};
//# sourceMappingURL=reducer.js.map